"use client"

import { useCallback, useEffect, useRef } from "react"

export const useScrollLock = () => {
  const originalOverflowRef = useRef<string>("")
  const isLockedRef = useRef<boolean>(false)

  const lockScroll = useCallback(() => {
    if (typeof document !== "undefined" && !isLockedRef.current) {
      originalOverflowRef.current = document.body.style.overflow
      document.body.style.overflow = "hidden"
      isLockedRef.current = true
    }
  }, [])
  const unlockScroll = useCallback(() => {
    if (typeof document !== "undefined" && isLockedRef.current) {
      document.body.style.overflow = originalOverflowRef.current || "auto"
      isLockedRef.current = false
    }
  }, [])
  useEffect(() => {
    return () => {
      if (isLockedRef.current) {
        unlockScroll()
      }
    }
  }, [unlockScroll])
  return { lockScroll, unlockScroll }
}
